module.exports = __webpack_public_path__ + "img/Gallery_2_10.dbe8dd25.jpeg";